"use client";

import { playerMarketingEmailsEnabled } from "@dailywars/core/marketing/preferences";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import { patchMyPlayerProfileQuery } from "#/lib/queries";
import { updateMyMarketingEmailsSetting } from "#/server/updateMyMarketingEmailsSetting";

import { ProfileToggleSetting } from "./-profile.toggleSetting";
import type { ProfileUserId } from "./-profile.types";

export function ProfileMarketingEmailsSetting({
  userId,
  profile,
}: {
  userId: ProfileUserId;
  profile: { marketingEmailsEnabled?: boolean };
}) {
  const queryClient = useQueryClient();

  const persist = useCallback(
    async (enabled: boolean) => {
      await updateMyMarketingEmailsSetting({ data: { enabled } });
      patchMyPlayerProfileQuery({
        queryClient,
        userId,
        patch: { marketingEmailsEnabled: enabled },
      });
    },
    [queryClient, userId],
  );

  return (
    <ProfileToggleSetting
      description="News and updates about Daily Wars. You can also unsubscribe from any email."
      initialEnabled={playerMarketingEmailsEnabled(profile)}
      persist={persist}
      switchId="profile-marketingEmails"
      title="Product emails"
    />
  );
}
